import styles from "./index.css";
import PropTypes from "prop-types";
import { withTranslation } from "../../translation";
import classnames from "classnames";

const SellingFastBadge = ({ className, formatTranslation, labelledById }) => (
  <div
    id={labelledById}
    aria-hidden={true}
    aria-label={formatTranslation("va_selling_fast_label")}
    className={classnames(styles.sellingFastBadge, className)}
  >
    {formatTranslation("selling_fast_label")}
  </div>
);

SellingFastBadge.propTypes = {
  isSellingFast: PropTypes.bool,
  className: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
  labelledById: PropTypes.string.isRequired
};

export default withTranslation(SellingFastBadge);
